import { CartIcon } from "../../../../assets";
import styles from "./style.module.css";

export const CartButton = () => {
  return (
    <div className={styles.container}>

      <CartIcon className={styles.icon} />
      
      Cart
    </div>
  );
};
